import axiosInstance from "../../../../Services/Global-Services/UnauthorizedTokenHandler";
import { checkStatus, getHeaders } from "../../../../Services/SharedSevices/SharedServices";
const baseurl = process.env.REACT_APP_ONLINE_TRAINING;


export const getOnlineTraining = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseurl}/OnlineTraining/List`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}


export const getCourseRating = async (params) => {
  try {
    const response = await axiosInstance.get(
      `${baseurl}/OnlineTraining/GetCourseRating`,
      {
        params: {
          courseId: params.courseId,
          userId: params.userId,
        },
        headers: await getHeaders(),
      }
    );
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const postSaveCourseRating = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseurl}/OnlineTraining/SaveCourseRating`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export const addCourses = async (body) => {
  try {
    const response = await axiosInstance.post(`${baseurl}/OnlineTraining/AddCourses`, body, {
      headers: await getHeaders(),
      body: JSON.stringify(body)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}


export const addModule = async (params) => {
  try {
    const response = axiosInstance.post(`${baseurl}/OnlineTraining/AddModules`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data
  } catch (err) {
    return Promise.reject(err)
  }
}


export const AddModuleLesson = async (params) => {
  try {
    const response = await axiosInstance.post(`${baseurl}/OnlineTraining/AddModuleLesson`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}


export async function SaveAnswer(params) {
  try {
    const response = await axiosInstance.post(`${baseurl}/OnlineTraining/SaveAnswer`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function AddQuestionOptions(params) {
  try {
    const response = await axiosInstance.post(`${baseurl}/OnlineTraining/AddQuestionOptions`, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function GetTraining(params) {
  try {
    const response = await axiosInstance.post(`${baseurl}/Training/List?OrgId=${params.OrgId}&TrainingId=${params.TrainingId}&UserId=${params.UserId}`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}



export async function TrainingEnrollment(params) {
  try {
    const response = await axiosInstance.post(`${baseurl}/Training/TrainingEnrollment`, params, {
      headers: await getHeaders(),
      body: JSON.stringify(params)
    });
    checkStatus(response);
    return response.data;
  } catch (error) {
    return Promise.reject(error);
  }
}